export const keyByValue = (obj: {}, value: string): string => {
  const output = Object.keys(obj).find((key) => obj[key] === value) || "";
  return output;
};
